import React from 'react';
import './styles.css';

const Radio = ({
  checked = false,
  onChange,
  value,
  name,
  disabled = false,
  ...props
}) => {
  console.log(checked, 'checked', { value });
  return (
    <label className="custom-radio">
      <input
        type="radio"
        checked={checked}
        onChange={onChange}
        value={value}
        name={name}
        disabled={disabled}
        {...props}
      />
      <span className="radio-checkmark"></span>
    </label>
  );
};

export default Radio;
